import { render, staticRenderFns } from "./OrderRequisites.vue?vue&type=template&id=456a4f13"
import script from "./OrderRequisites.vue?vue&type=script&lang=js"
export * from "./OrderRequisites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports